export const APP_CONSTANTS = {
    "USER_ROLES": {
        "ALL": 0,
        "ADMIN": 1,
        "SEO": 2,
        "HR": 3,
        "USER": 4
    },
    "BLOG_CATEGORY": {
        "backend.INVALID_BLOG_CATEGORY_ID": "Invalid Id",
        "backend.INVALID_BLOG_CATEGORY_NAME": "Invalid Name",
        "backend.INVALID_BLOG_CATEGORY_PARENT_ID": "Invalid Parent Id",
        "backend.INVALID_BLOG_CATEGORY_SEO_TITLE": "Invalid SEO Title",
        "backend.INVALID_BLOG_CATEGORY_SEO_KEYWORDS": "Invalid SEO Keywords",
        "backend.INVALID_BLOG_CATEGORY_SEO_DESCRIPTION": "Invalid SEO Description",
        "backend.BLOG_CATEGORY_VALIDATION": "Invalid Data of Blog Category",
        "backend.BLOG_CATEGORY_LISTING": "Blog Categories have been fetched",
        "backend.BLOG_CATEGORY_SAVED": "Blog Category has been saved",
        "backend.BLOG_CATEGORY_UPDATED": "Blog Category has been updated",
        "backend.BLOG_CATEGORY_DELETED": "Blog Category has been deleted"
    },
    "BLOG": {
        "backend.INVALID_BLOG_ID": "Invalid Id",
        "backend.INVALID_BLOG_TITLE": "Invalid Title",
        "backend.INVALID_BLOG_IMAGE": "Invalid Image",
        "backend.INVALID_BLOG_DESCRIPTION": "Invalid Description",
        "backend.INVALID_BLOG_PUBLISH_DATE": "Invalid Publish Date",
        "backend.INVALID_BLOG_CATEGORY_ID": "Invalid Category ID",
        "backend.INVALID_BLOG_ADDITIONAL_TAGS": "Invalid Additional Tags",
        "backend.INVALID_BLOG_CUSTOM_SCRIPT": "Invalid Custom Script",
        "backend.INVALID_BLOG_SHORT_DESCRIPTION": "Invalid Shot Description",
        "backend.INVALID_BLOG_SEO_TITLE": "Invalid SEO Title",
        "backend.INVALID_BLOG_SEO_KEYWORDS": "Invalid SEO Keywords",
        "backend.INVALID_BLOG_SEO_DESCRIPTION": "Invalid SEO Description",
        "backend.BLOG_VALIDATION": "Invalid Data of Blog",
        "backend.BLOG_CONFIGURATION": "Blog Configuration has been fetched",
        "backend.BLOG_LISTING": "Blogs have been fetched",
        "backend.BLOG_SAVED": "Blog has been saved",
        "backend.BLOG_UPDATED": "Blog has been updated",
        "backend.BLOG_DELETED": "Blog has been deleted",
    },
};